import { HotelFiltersPayloadState } from '@hotels/hotel-results/store/reducers/hotel-filters-payload.reducer';
import { HotelResultsUiModuleState } from '@hotels/hotel-results/store/state/hotel-results-ui-module.state';
import { HotelResultsState } from '@hotels/hotel-results/store/reducers/hotel-results.reducer';
import { HotelTopZonesState } from '@hotels/hotel-results/store/reducers/hotel-top-zones.reducer';

export const hotelResultsFeatureName = 'hotelResultsModuleState';

export type HotelResultsModuleState = Readonly<{
  hotelResults: HotelResultsState,
  hotelFiltersPayload: HotelFiltersPayloadState,
  hotelTopZones: HotelTopZonesState,
  ui: HotelResultsUiModuleState
}>;
